import { HTMLAttributes } from "react";
import cn from "classnames";

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  /** Lift and blue-glow the border on hover (marketing `.glass-card`). */
  interactive?: boolean;
}

/** Marketing card surface: 16px radius, soft double shadow, optional hover glow. */
export default function GlassCard({
  interactive = true,
  className,
  children,
  ...props
}: GlassCardProps) {
  return (
    <div
      className={cn(
        "rounded-card bg-base-100 border border-base-300 shadow-card",
        interactive &&
          "transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-0.5 hover:shadow-card-hover hover:border-blue-500/30",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
